<template>
     <!--MODAL LISTE OUVRIERS -->
    <v-dialog v-model="dialogOuvrier" :persistent="true" width="90%" scrollable>
      <v-card tile>
        <v-toolbar card dark color="primary">
          <v-toolbar-title>LISTE DES OUVRIERS ET PRESTATAIRE AFFECTES A LA TACHE: {{tacheSelect.tacheLibelle}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click.native=" closeDialog() ">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <h4 mt-2>LISTE DES OUVRIERS</h4>
          <v-divider></v-divider>
          <v-layout row elevation-2>
            <v-flex sm12 mt-2>
              <data-tables mt-3 ml-1 mr-1 :data="listeOuvriers" style="width:99%;">
                <el-table-column prop="idContrat" label="Contrat" align="center" width="100" fixed>
                  <template slot-scope="scope">CONT-{{scope.row.idContrat}}</template>
                </el-table-column>
                <el-table-column prop="nom" label="NOM" align="center" width="230" fixed></el-table-column>
                <el-table-column prop="dateC"  label="DATE" align="center"></el-table-column>
                <el-table-column prop="dateD" label="Début"></el-table-column>
                <el-table-column prop="dateF" label="Fin"></el-table-column>
                <!-- <el-table-column prop="duree" label="Durée (Jours) "></el-table-column> -->
                <el-table-column prop="montant" label="MONTANT/JOUR" align="center"></el-table-column>
                <el-table-column prop="montantHeur" label="MONTANT/H" align="center"></el-table-column>
                <el-table-column prop="montantSupp" label="MONTANT HEURE SUPP" align="center"></el-table-column>
                <el-table-column prop="etatContrat" label="Etat contrat" align="center"></el-table-column>
              </data-tables>
            </v-flex>
          </v-layout>
          <br />
          <h4 mt-2>LISTE DES PRESTATAIRES</h4>
          <v-divider></v-divider>
          <v-layout row  elevation-2>
            <v-flex sm12 mt-2>
              <data-tables mt-3 ml-1 mr-1 :data="listePrestataires" style="width:99%;">
                <el-table-column prop="idContrat" label="Contrat" align="center" width="100" fixed>
                  <template slot-scope="scope">CONT-{{scope.row.idContrat}}</template>
                </el-table-column>
                <el-table-column prop="nom" label="NOM" align="center" width="230" fixed></el-table-column>
                <el-table-column prop="dateC"  label="DATE" align="center"></el-table-column>
                <el-table-column prop="dateD" label="Début"></el-table-column>
                <el-table-column prop="dateF" label="Fin"></el-table-column>
                <!-- <el-table-column prop="duree" label="Durée (Jours) "></el-table-column> -->
                <el-table-column prop="montant" label="MONTANT/JOUR" align="center"></el-table-column>
                <el-table-column prop="montantHeur" label="MONTANT/H" align="center"></el-table-column>
                <el-table-column prop="montantSupp" label="MONTANT HEURE SUPP" align="center"></el-table-column>

                <el-table-column prop="etatContrat" label="Etat contrat" align="center"></el-table-column>
              </data-tables>
            </v-flex>
          </v-layout>
          <v-divider></v-divider>

          <!--BOUTON VALIDATION-->
          <v-layout row class="text-xs-right"></v-layout>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>
    <!--MODAL LISTE OUVRIERS FIN -->
</template>

<script>
import Loading from "@/components/Loading";
export default {
  components: { Loading },
  name: "IndexOuvrierTrx",
  props: {
    show: {
      type: Boolean
    },
    detailTrx: {
      type: Object
    },
    tacheSelect:{
        type: Object
    }
  },
  data() {
    return {
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      dialogTache: false,
      loading: false,
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      listeTache: [],
      dialogOuvrier: false,
      dialogDemarrer: false,
      dialogConfirmRefus: false,
      listePrestataires: [],
      listePrestOuvriers:[],
      listePresence: [],
      listeOuvriers: [],
      formRefus: {},
      presenceSelect:{},
    //   tacheSelect: {
    //     libelle: ""
    //   },
      dialogTermine: false,
      formDemarrer: {},
      prestataireSelect:{
        idContrat: null,
        datePresence : null,
        file: null
      },
      tablePrestataire: [],
      dialogSuprPresence: false,
      imageRes: "/static/avatar-conducteur.png",

    };
  },
  methods: {
    closeDialog() {
        this.dialogOuvrier = false;
      this.$emit("close");
    },

    loadOuvrier(tache) {
      this.prestataireSelect.datePresence = null;
      this.prestataireSelect.idContrat = null;
      this.loading = true;
      let url =""
      if(tache.idOpt) {
        url = this.domaine + "ouvrier/optionTravaux/" + tache.idOpt;
      }else{
        url = this.domaine + "ouvrier/optionTravaux/" + tache.id;

      }

      this.$http.get(url).then(
        response => {
          this.listeOuvriers = response.body.ouvriers;
          this.listePrestataires = response.body.prestataires;
          this.listePrestOuvriers = response.body.listePresOuvriers;
          this.listePresence = response.body.listePresence;
          this.dialogOuvrier = true;
          this.loading = false;
        },
        error => {
          this.loading = false;
          this.$message.error("Echec lors du chargement des ouvriers");
        }
      );
    },
    submitFormDemarrer(formName) {
      if (
        this.formDemarrer.dateDbt != "undefined" &&
        this.formDemarrer.hrDbt != null &&
        (this.formDemarrer.hrDbt != "undefined" &&
          this.formDemarrer.hrDbt != null)
      ) {
        this.loading = true;
        let url =
          this.domaine +
          "tache/demarrer/optionTrx/" +
          this.tacheSelect.idOpt;
        let data = new FormData();

        let dateDbt =
          this.formDemarrer.dateDbt.getFullYear() +
          "-" +
          this.formDemarrer.dateDbt.getMonth() +
          "-" +
          this.formDemarrer.dateDbt.getDate();
        let hrDbt =
          this.formDemarrer.hrDbt.getHours() +
          ":" +
          this.formDemarrer.hrDbt.getMinutes();

        data.append("dateDbt", dateDbt);
        data.append("hrDbt", hrDbt);
        this.$http.post(url, data).then(
          response => {
            this.loading = false;
            //reinitialiser le formulaire
            this.dialogDemarrer = false;

            let mess = response.body.message;
            this.loadTache(this.detailTrx);
            this.$notify({
              title: "ENREGISTREMENT REUSSI",
              message: mess,
              type: "success",
              position: "top-center"
            });
          },
          erreur => {
            //reinitialiser le formulaire
            this.resetForm("formDemarrer");
            this.loading = false;
            this.$message.error("L'opération a echouée");
          }
        );
      } // verifie champs date
      else {
        this.$message.error(
          "Veuillez remplir correctement la date et l'heure svp..."
        );
      }
    },
    submitFormStop(formName) {
      if (
        this.formRefus.rapport != "undefined" &&
        this.formRefus.rapport != null
      ) {
        this.loading = true;
        let url =
          this.domaine + "tache/arret/stop/tachetrx/" + this.tacheSelect.idOpt;
        let data = new FormData();

        data.append("idUser", this.user.id);
        data.append("rapport", this.formRefus.rapport);

        this.$http.post(url, data).then(
          response => {
            //reinitialiser le formulaire
            this.loading = false;
            this.dialogConfirmRefus = false;
            this.formRefus.rapport = "";
            let mess = response.body.message;
            this.loadTache(this.detailTrx);

            this.$notify({
              title: "ENREGISTREMENT REUSSI",
              message: mess,
              type: "success",
              position: "top-center"
            });
          },
          erreur => {
            //reinitialiser le formulaire
            this.formRefus.rapport = "";
            this.loading = false;
            this.$message.error("L'opération a echouée");
          }
        );
      } //rapport non saisie
      else {
        this.$message.error("Veuillez remplir correctement les champs svp...");
      }
    },

    submitRelanceTache() {
      this.loading = true;
      let url =
        this.domaine + "tache/relance/optionTrx/" + this.tacheSelect.idOpt;
      let data = new FormData();
      data.append("idUser", this.user.id);
      this.$http.post(url, data).then(
        response => {
          //reinitialiser le formulaire
          this.loading = false;


          let mess = response.body.message;
          this.$emit("reloadListeTravaux");
          this.loadTache(this.detailTrx);

          this.$notify({
            title: "ENREGISTREMENT REUSSI",
            message: mess,
            type: "success",
            position: "top-center"
          });
        },
        erreur => {
          this.loading = false;
          this.$message.error("L'opération a echouée");
        }
      );
    },

    submitTacheTerminer() {
      this.loading = true;
      let url =
        this.domaine + "tache/termine/optionTrx/" + this.tacheSelect.idOpt;
      let data = new FormData();
      data.append("idUser", this.user.id);
      this.$http.post(url, data).then(
        response => {
          //reinitialiser le formulaire
          this.loading = false;
          this.dialogTermine = false;

          let mess = response.body.message;
          this.loadTache(this.detailTrx);

          this.$notify({
            title: "ENREGISTREMENT REUSSI",
            message: mess,
            type: "success",
            position: "top-center"
          });
        },
        erreur => {
          this.loading = false;
          this.$message.error("L'opération a echouée");
        }
      );
    },

    submitPresence(){
      if( this.prestataireSelect.idContrat == null || this.prestataireSelect.idContrat == "undefined" || this.prestataireSelect.datePresence == "undefined" || this.prestataireSelect.datePresence == null   ){
        this.$message.error("Veuillez renseigner correctement les champs");
        return;
      }
      ///this.loading = true;
      let url =
      this.domaine + "presence/new";
      let data = new FormData();
      data.append("idUser", this.user.id);
      data.append("idContrat", this.prestataireSelect.idContrat);
      data.append("datePresence", this.prestataireSelect.datePresence);
      data.append("fichierRes", this.prestataireSelect.file, this.prestataireSelect.file[name]);


       this.$http.post(url, data).then(
        response => {
          //reinitialiser le formulaire

          this.loading = false;
          let mess = response.body.message;
          this.imageRes = "/static/avatar-conducteur.png";


          this.$notify({
            title: "ENREGISTREMENT REUSSI",
            message: mess,
            type: "success",
            position: "top-center"
          });

          this.loadOuvrier(this.tacheSelect);
          this.loading = false;
        },
        erreur => {
          this.loading = false;
          this.$message.error("L'opération a echouée");
        }
      );
    },

    deletePresence(idPresence){


      this.loading = true;

      let url =
        this.domaine + "presence/delete/" + idPresence;
      this.$http.get(url).then(
        response => {
          this.loading = false;

          this.$notify({
            title: "SUPPRESSION REUSSIE",
            message: "Demande supprimée avec succès.",
            type: "success",
            position: "top-center"
          });
          this.dialogSuprPresence = false;

          this.loadOuvrier(this.tacheSelect);
        },
        errRep => {
          this.loading = false;
          this.dialogSuprPresence = false;
          this.$notify.error({
            title: "SUPPRESSION ECHOUEE",
            message: "La suppression de la demande a échouée.",
            position: "top-center"
          });
        }
      );

    },
     onFileResPicked(event)
                {
                    console.log("onfileChange files res",event.target.files);
                    const files = event.target.files
                    let filename = files[0].name
                    if (filename.lastIndexOf(".") <= 0) {
                        return alert("Veuillez selectionner un  format de fichier valide ")
                    }
                    if( files[0].size > 1048576  ){
                        this.$message.error("La taille du fichier est supérieur à 1024 ko");
                        return;
                    }

                    const fileReader = new FileReader()
                    fileReader.addEventListener("load", () => {
                        console.log("loader addevent")
                        this.imageRes = fileReader.result

                        console.log("loader image ",this.imageRes)
                    })

                    fileReader.readAsDataURL(files[0])
                    this.prestataireSelect.file = files[0]
                    //this.file = files[0];
                    console.log("file 0 ",files[0])
                },



  },

  watch: {
    show: function(newValue, oldvalue) {
      this.dialogOuvrier = newValue;
      console.log("tache select", this.tacheSelect);
      if (newValue) {
        console.log('oui')
        this.loadOuvrier(this.tacheSelect);
      }
    }
  }
};
</script>

<style lang="stylus">
.list__tile__title {
  height: 600px;
}

.list {
  height: 600px;
}
</style>



// WEBPACK FOOTER //
// src/components/boardTravaux/IndexOuvrierTrx.vue